import axios from 'axios';

const API_URL = process.env.API_URL;

export async function updateProfile(authorization, user) {
  const url = `${API_URL}/dashboard/account/update`;
  return axios({
    url,
    method: 'post',
    data: user,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function updateBank(authorization, bank) {
  const url = `${API_URL}/dashboard/account/add-bank`;
  const accessType = localStorage.getItem('token_type');
  const accessToken = localStorage.getItem('access_token');
  return axios.post(url, bank, {
    headers: {
      Authorization: `${accessType} ${accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function acceptToc(authorization) {
  const url = `${API_URL}/dashboard/account/accept-toc`;
  return axios({
    url,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function createUser(authorization, user) {
  const url = `${API_URL}/admin/user/create`;
  return axios({
    url,
    method: 'post',
    data: user,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function updateUser(authorization, user) {
  const url = `${API_URL}/admin/user/update`;
  return axios({
    url,
    method: 'post',
    data: user,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getListUser(authorization, filter) {
  const url = `${API_URL}/admin/user/list`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function getListUserApp(authorization, filter) {
  const url = `${API_URL}/admin/user-app/list`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getDetailUser(authorization, idUser) {
  const url = `${API_URL}/admin/user/detail/${idUser}`;
  return axios({
    url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getDetailUserApp(authorization, idUser) {
  const url = `${API_URL}/admin/user-app/detail/${idUser}`;
  return axios({
    url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function setBlockUser(authorization, data) {
  const url = `${API_URL}/admin/user-app/block`;
  return axios({
    url,
    method: 'post',
    data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function setUnblockUser(authorization, data) {
  const url = `${API_URL}/admin/user-app/unblock`;
  return axios({
    url,
    method: 'post',
    data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function setUserPremium(authorization, data) {
  const url = `${API_URL}/admin/user-app/set-premium`;
  return axios({
    url,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function deleteUserByEmail(authorization, email) {
  const url = `${API_URL}/admin/user-app/delete`;
  return axios({
    url,
    method: 'post',
    data: { email },
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function changePasswordUserAdmin(authorization, user) {
  const url = `${API_URL}/admin/user/change-password`;
  return axios({
    url,
    method: 'post',
    data: user,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function changePasswordUserArtist(authorization, user) {
  const url = `${API_URL}/admin/user-artist/change-password`;
  return axios({
    url,
    method: 'post',
    data: user,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function deleteUserAdminByEmail(authorization, email) {
  const url = `${API_URL}/admin/user/delete-by-email`;
  return axios({
    url,
    method: 'post',
    data: { email },
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function deleteUserById(authorization, data) {
  const url = `${API_URL}/admin/user-app/delete`;
  return axios({
    url,
    method: 'post',
    data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getListTransactionUserByType(authorization, user_id, type, filter) {
  const url = `${API_URL}/admin/user-app/transaction/${user_id}`;
  return axios({
    url,
    method: 'get',
    params: { ...filter, type },
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function resendEmail(authorization, data) {
  const url = `${API_URL}/admin/user-app/resend-activation-email`;
  return axios({
    url,
    method: 'post',
    data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getListUserAppDeleted(authorization, filter) {
  const url = `${API_URL}/admin/user-app/list-deleted`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getDetailUserDeleted(authorization, idUser) {
  const url = `${API_URL}/admin/user-app/detail-deleted/${idUser}`;
  return axios({
    url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export const userService = {
  updateProfile,
};



// WEBPACK FOOTER //
// ./src/services/user.js